import { useEffect } from 'react';
import PropTypes from 'prop-types';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
//
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

const SUPERADMIN_ONLY = ['superadmin'];

// `roles` widens the guard for a screen another cross-org role may read (the National dashboard).
export default function SuperAdminGuard({ children, redirectTo, roles = SUPERADMIN_ONLY }) {
  const router = useRouter();
  const { user } = useAuthContext();

  // Wait for user to be loaded
  const isLoading = !user;

  const userRole = user?.users_user_roles?.length
    ? user?.users_user_roles[0].user_roles_roles?.code
    : null;

  useEffect(() => {
    if (isLoading) return; // Don't run logic until data is loaded

    // If user is not a superadmin, redirect — to the dashboard by default, or wherever the caller
    // says. A guarded screen that has a non-superadmin equivalent (e.g. the rebuilt voter search vs
    // the classic one) should send them to that instead of dumping them on the dashboard.
    if (!!userRole && !roles.includes(userRole)) {
      router.replace(redirectTo || paths.dashboard.root);
    }
  }, [userRole, router, isLoading, redirectTo, roles]);

  // Only render children if user holds an allowed role
  if (roles.includes(userRole)) {
    return <>{children}</>;
  }

  // If user is not superadmin or still loading, don't render children (will redirect)
  return null;
}

SuperAdminGuard.propTypes = {
  children: PropTypes.node,
  redirectTo: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
};
